module.exports = __webpack_public_path__ + "static/search4-4c658aff746245cc991af168a44b9e1b.png";